import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";

export default function Report() {
    const { school } = useAuth();
    const [overview, setOverview] = useState({});
    const [classes, setClasses] = useState([]);
    useEffect(() => {
        api.get("/admin/overview").then(r => setOverview(r.data));
        api.get("/classes").then(r => setClasses(r.data));
    }, []);
    const today = new Date().toLocaleDateString("ar-EG");

    return (
        <div className="max-w-4xl mx-auto space-y-4">
            <div className="no-print flex items-center justify-between">
                <div>
                    <h1 className="text-2xl font-bold text-[#0F172A]">تقرير عام</h1>
                    <p className="text-sm text-slate-500 mt-1">ملخص قابل للطباعة</p>
                </div>
                <Button onClick={() => window.print()} data-testid="btn-print" className="bg-[#1B2A4E] hover:bg-[#0F172A]"><Printer className="w-4 h-4 ml-2" /> طباعة</Button>
            </div>

            <div className="bg-white rounded-xl border-2 border-[#1B2A4E] p-8 print:border-black print:rounded-none">
                {/* Header */}
                <div className="flex items-start justify-between pb-6 border-b-2 border-[#1B2A4E]">
                    <div className="text-right">
                        <div className="text-lg font-bold text-[#1B2A4E]">{school.name}</div>
                        <div className="text-sm text-slate-600 mt-1">تقرير المنظومة</div>
                    </div>
                    {school.logo_url && <img src={school.logo_url} alt="شعار" className="w-20 h-20 object-contain" />}
                    <div className="text-left text-xs text-slate-600">
                        <div>التاريخ: <span className="font-mono-num" dir="ltr">{today}</span></div>
                        <div className="mt-1">العام الدراسي: 1447-1448</div>
                    </div>
                </div>

                {/* Content */}
                <div className="py-6 space-y-6">
                    <section>
                        <h2 className="text-lg font-bold text-[#1B2A4E] border-r-4 border-[#C8102E] pr-3 mb-3">إحصاءات عامة</h2>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                            {[["عدد الطالبات", overview.students_count], ["أولياء الأمور", overview.parents_count], ["المدربات", overview.trainers_count], ["الفصول", overview.classes_count]].map(([l, v], i) => (
                                <div key={i} className="border border-slate-300 rounded-lg p-3 text-center">
                                    <div className="text-2xl font-bold text-[#1B2A4E] font-mono-num">{v ?? "-"}</div>
                                    <div className="text-xs text-slate-600 mt-1">{l}</div>
                                </div>
                            ))}
                        </div>
                    </section>
                    <section>
                        <h2 className="text-lg font-bold text-[#1B2A4E] border-r-4 border-[#C8102E] pr-3 mb-3">توزيع الفصول</h2>
                        <table className="w-full text-sm border border-slate-300">
                            <thead className="bg-slate-100"><tr><th className="px-3 py-2 text-right border-l border-slate-300">الصف</th><th className="px-3 py-2 text-right border-l border-slate-300">الفصل</th><th className="px-3 py-2 text-right">عدد الطالبات</th></tr></thead>
                            <tbody>{classes.map((c) => (<tr key={c.id} className="border-t border-slate-300"><td className="px-3 py-2 border-l border-slate-300">{c.grade}</td><td className="px-3 py-2 border-l border-slate-300">{c.section}</td><td className="px-3 py-2 font-mono-num">{c.student_count}</td></tr>))}</tbody>
                        </table>
                    </section>
                </div>

                {/* Footer */}
                <div className="pt-6 border-t border-slate-300 grid grid-cols-2 gap-8 text-sm text-slate-600">
                    <div><div className="mb-8">توقيع الإدارة:</div><div className="border-t border-slate-400 pt-1 text-xs">___________________</div></div>
                    <div className="text-left"><div className="mb-8">الختم الرسمي:</div><div className="text-xs">___________________</div></div>
                </div>
                <div className="text-center text-[10px] text-slate-400 mt-4">أُنشئ بواسطة نظام "بقدراتنا نسمو" • {new Date().toISOString().slice(0, 19)}</div>
            </div>
        </div>
    );
}
